import { AxiosResponse } from 'axios';
import { pipe } from 'ramda';
import { useQuery } from 'react-query';

import { DutyHourTypeWithDetails } from '../../types';
import { DutyHourTypeDto } from 'components/types';

import { dutyHourTypeConverter } from '../../utils/dutyHourTypeConverter';
import { isNotNil } from 'utils/ramdaUtils';

import { getDutyHourTypeById } from 'RestAPIs/dutyHourTypes';

export const useGetDetails = (rowId?: number | null) =>
  useQuery({
    queryKey: ['dutyHourType', 'details', rowId],
    enabled: isNotNil(rowId),
    queryFn: async () =>
      await getDutyHourTypeById(rowId).then(
        pipe<
          [AxiosResponse<DutyHourTypeDto>],
          DutyHourTypeDto,
          DutyHourTypeWithDetails
        >((value) => value.data, dutyHourTypeConverter)
      )
  });
